import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "matrix" }
const _hoisted_3 = { class: "matrix__grid" }
const _hoisted_4 = ["onClick", "onDragover", "onDragleave", "onDrop"]
const _hoisted_5 = { class: "quadrant__header" }
const _hoisted_6 = { class: "quadrant__title" }
const _hoisted_7 = {
  key: 0,
  class: "quadrant__count"
}
const _hoisted_8 = ["onDragover", "onDrop"]
const _hoisted_9 = ["data-id", "onClick", "onDragstart"]
const _hoisted_10 = ["title"]
const _hoisted_11 = {
  key: 0,
  class: "task__age-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_12 = {
  key: 1,
  class: "task__age-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_13 = {
  key: 2,
  class: "task__age-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_14 = { class: "task__age-label" }
const _hoisted_15 = { class: "task__text" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "quadrant__empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TaskPopover = _resolveComponent("TaskPopover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("header", { class: "page__head" }, [
      _createElementVNode("img", {
        class: "page__logo",
        src: _imports_0,
        alt: "Матрица Эйзенхауэра"
      }),
      _createElementVNode("h1", { class: "page__title" }, "Матрица Эйзенхауэра"),
      _createElementVNode("p", { class: "page__subtitle" }, " Кликните по любой области, чтобы добавить задачу. Перетаскивайте задачи между квадрантами. ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "matrix__corner" }, null, -1)),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "matrix__col-labels" }, [
        _createElementVNode("span", null, "СРОЧНО"),
        _createElementVNode("span", null, "НЕСРОЧНО")
      ], -1)),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "matrix__row-labels" }, [
        _createElementVNode("span", null, "ВАЖНО"),
        _createElementVNode("span", null, "НЕВАЖНО")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quadrants, (q) => {
          return (_openBlock(), _createElementBlock("section", {
            key: q.id,
            class: _normalizeClass(["quadrant", { 'quadrant--over': _ctx.dragOver === q.id }]),
            style: _normalizeStyle({ '--accent': q.accent, '--ink': q.textOnAccent }),
            onClick: ($event: any) => (_ctx.onSurfaceClick($event, q.id)),
            onDragover: _withModifiers(($event: any) => (_ctx.onQuadrantDragOver(q.id)), ["prevent"]),
            onDragleave: ($event: any) => (_ctx.onDragLeave(q.id)),
            onDrop: _withModifiers(($event: any) => (_ctx.onDrop(q.id)), ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h2", _hoisted_6, _toDisplayString(q.title), 1),
              (_ctx.tasksByQuadrant[q.id].length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.tasksByQuadrant[q.id].length), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: "quadrant__tasks",
              onDragover: _withModifiers(($event: any) => (_ctx.onListDragOver($event, q.id)), ["prevent","stop"]),
              onDrop: _withModifiers(($event: any) => (_ctx.onDrop(q.id)), ["prevent","stop"])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tasksByQuadrant[q.id], (task) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: task.id,
                  class: _normalizeClass(["task", {
                'task--dragging': _ctx.dragging === task.id,
                'task--drop-before': _ctx.dropBeforeId(q.id) === task.id,
                'task--drop-after':
                  _ctx.dropBeforeId(q.id) === 'end' && _ctx.lastTaskId(q.id) === task.id
              }]),
                  "data-id": task.id,
                  draggable: "true",
                  onClick: _withModifiers(($event: any) => (_ctx.onTaskClick($event, task)), ["stop"]),
                  onDragstart: ($event: any) => (_ctx.onDragStart(task)),
                  onDragend: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDragEnd && _ctx.onDragEnd(...args)))
                }, [
                  (_ctx.isUrgent(q.id))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["task__age", `task__age--${_ctx.taskAgeLevel(task)}`]),
                        title: `висит ${_ctx.taskAgeLabel(task)}`
                      }, [
                        (_ctx.taskAgeLevel(task) === 'fresh')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_11, [...(_cache[2] || (_cache[2] = [
                              _createElementVNode("circle", {
                                cx: "12",
                                cy: "12",
                                r: "9"
                              }, null, -1),
                              _createElementVNode("path", { d: "M12 7.5V12l3 2" }, null, -1)
                            ]))]))
                          : (_ctx.taskAgeLevel(task) === 'warning')
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_12, [...(_cache[3] || (_cache[3] = [
                                _createElementVNode("path", { d: "M6 3h12M6 21h12" }, null, -1),
                                _createElementVNode("path", { d: "M7 3v3.2a2 2 0 0 0 .6 1.4L12 12l4.4-4.4A2 2 0 0 0 17 6.2V3" }, null, -1),
                                _createElementVNode("path", { d: "M7 21v-3.2a2 2 0 0 1 .6-1.4L12 12l4.4 4.4a2 2 0 0 1 .6 1.4V21" }, null, -1)
                              ]))]))
                            : (_openBlock(), _createElementBlock("svg", _hoisted_13, [...(_cache[4] || (_cache[4] = [
                                _createElementVNode("path", { d: "M8.5 14.5A2.5 2.5 0 0 0 11 17a2.5 2.5 0 0 0 2.5-2.5c0-1.4-.5-2-1-3-1.1-2.1-.2-4 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.2.4-2.3 1-3a2.5 2.5 0 0 0 2.5 2.5z" }, null, -1)
                              ]))])),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.taskAgeShort(task)), 1)
                      ], 10, _hoisted_10))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(task.title), 1),
                  _createElementVNode("button", {
                    class: "task__remove",
                    type: "button",
                    "aria-label": "Удалить задачу",
                    onClick: _withModifiers(($event: any) => (_ctx.removeTask(task.id)), ["stop"])
                  }, " × ", 8, _hoisted_16)
                ], 42, _hoisted_9))
              }), 128)),
              (!_ctx.tasksByQuadrant[q.id].length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_17, " + добавить задачу "))
                : _createCommentVNode("", true)
            ], 40, _hoisted_8)
          ], 46, _hoisted_4))
        }), 128))
      ])
    ]),
    (_ctx.popover)
      ? (_openBlock(), _createBlock(_component_TaskPopover, {
          key: _ctx.popover.key,
          mode: _ctx.popover.mode,
          x: _ctx.popover.x,
          y: _ctx.popover.y,
          "initial-title": _ctx.popover.initialTitle,
          quadrant: _ctx.popover.quadrant,
          accent: _ctx.accentOf(_ctx.popover.quadrant),
          onSave: _ctx.onPopoverSave,
          onMove: _ctx.onPopoverMove,
          onDelete: _ctx.onPopoverDelete,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.popover = null))
        }, null, 8, ["mode", "x", "y", "initial-title", "quadrant", "accent", "onSave", "onMove", "onDelete"]))
      : _createCommentVNode("", true)
  ]))
}